import { Controller } from '@hotwired/stimulus';

export class DropzoneController extends Controller {
  static targets = [
    'input',
  ];
  static values = {
    active: Boolean,
  };

  #depth = 0;

  browse() {
    this.inputTarget.click();
  }

  dragenter(event) {
    if (this.inputTarget.disabled || !event.dataTransfer?.types.includes('Files')) return;

    this.#depth += 1;
    this.activeValue = true;
  }

  dragleave() {
    if (this.#depth === 0) return;

    this.#depth -= 1;

    if (this.#depth === 0) this.activeValue = false;
  }

  dragover(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();

    this.#depth = 0;
    this.activeValue = false;

    if (this.inputTarget.disabled) return;

    this.#receive(event.dataTransfer.files);
  }

  select() {
    this.#receive(this.inputTarget.files);

    this.inputTarget.value = '';
  }

  #receive(filelist) {
    const files = [...filelist].slice(0, this.inputTarget.multiple ? undefined : 1);

    if (files.length === 0) return;

    this.dispatch('selected', { detail: { files } });
  }
}
